<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
  >
    <path
      d="M33.75 8.89258H27.5V7.64258C27.5 6.64802 27.1049 5.69419 26.4017 4.99093C25.6984 4.28767 24.7446 3.89258 23.75 3.89258H16.25C15.2554 3.89258 14.3016 4.28767 13.5983 4.99093C12.8951 5.69419 12.5 6.64802 12.5 7.64258V8.89258H6.25C5.58696 8.89258 4.95107 9.15597 4.48223 9.62481C4.01339 10.0937 3.75 10.7295 3.75 11.3926V31.3926C3.75 32.0556 4.01339 32.6915 4.48223 33.1603C4.95107 33.6292 5.58696 33.8926 6.25 33.8926H33.75C34.413 33.8926 35.0489 33.6292 35.5178 33.1603C35.9866 32.6915 36.25 32.0556 36.25 31.3926V11.3926C36.25 10.7295 35.9866 10.0937 35.5178 9.62481C35.0489 9.15597 34.413 8.89258 33.75 8.89258ZM15 7.64258C15 7.31106 15.1317 6.99312 15.3661 6.75869C15.6005 6.52427 15.9185 6.39258 16.25 6.39258H23.75C24.0815 6.39258 24.3995 6.52427 24.6339 6.75869C24.8683 6.99312 25 7.31106 25 7.64258V8.89258H15V7.64258ZM33.75 11.3926V17.8941C29.5309 20.1907 24.8036 21.3934 20 21.3926C15.1966 21.3935 10.4694 20.1912 6.25 17.8957V11.3926H33.75ZM33.75 31.3926H6.25V20.7113C10.5311 22.8054 15.2342 23.8935 20 23.8926C24.7659 23.8927 29.4689 22.8041 33.75 20.7098V31.3926ZM16.25 17.6426C16.25 17.3111 16.3817 16.9931 16.6161 16.7587C16.8505 16.5243 17.1685 16.3926 17.5 16.3926H22.5C22.8315 16.3926 23.1495 16.5243 23.3839 16.7587C23.6183 16.9931 23.75 17.3111 23.75 17.6426C23.75 17.9741 23.6183 18.292 23.3839 18.5265C23.1495 18.7609 22.8315 18.8926 22.5 18.8926H17.5C17.1685 18.8926 16.8505 18.7609 16.6161 18.5265C16.3817 18.292 16.25 17.9741 16.25 17.6426Z"
      :fill="fill"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'V2IconsBriefcase'
})

defineProps({
  fill: {
    type: String,
    default: '#671CC2'
  }
})
</script>
